import React from 'react';
import { Tooltip } from '@material-ui/core';
import { ChevronRight, ChevronDown } from 'tabler-icons-react';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import LlamadaCard from './LlamadaCard';

// Acordeón custom por color de severidad. Sigue el mismo patrón de
// src/components/LineaAccordion.jsx: header <button> + chevron, cuerpo
// condicional, expansión controlada por el padre.
function ColorAccordion({ color, llamadas, expanded, onToggle, dragDisabled }) {
    return (
        <div className={`llam-color-acc llam-color-acc--${color.slug}`}>
            <button
                type="button"
                className="llam-color-head"
                onClick={onToggle}
                aria-expanded={expanded}
            >
                {expanded ? <ChevronDown size={18} /> : <ChevronRight size={18} />}
                <span className={`llam-color-dot llam-color-dot--${color.slug}`} />
                <span className="llam-color-name">{color.nombre}</span>
                <Tooltip
                    title={`${llamadas.length} llamada${llamadas.length === 1 ? '' : 's'}`}
                    arrow
                >
                    <span className="llam-color-count">{llamadas.length}</span>
                </Tooltip>
            </button>

            {expanded && (
                <div className="llam-color-body">
                    {llamadas.length === 0 ? (
                        <div className="llam-empty">Sin llamadas de este color</div>
                    ) : (
                        <SortableContext
                            items={llamadas.map((llamada) => llamada.tipoLlamada)}
                            strategy={verticalListSortingStrategy}
                        >
                            {llamadas.map((llamada, index) => (
                                <LlamadaCard
                                    key={llamada.tipoLlamada}
                                    llamada={llamada}
                                    posicion={index + 1}
                                    disabled={dragDisabled}
                                />
                            ))}
                        </SortableContext>
                    )}
                </div>
            )}
        </div>
    );
}

export default ColorAccordion;
